import React from 'react'

import CreditOverview from '../components/credit-overview/index'

class CreditOverviewPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<CreditOverview />
			</div>
		)
	}

}

export default CreditOverviewPage;


// WEBPACK FOOTER //
// ./src/containers/credit-overview-page.js